import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const VideoCard = ({ id, snippet }) => {
  if (!snippet) {
    return;
  }

  return (
    <Card
      sx={{
        width: { xs: "100%", sm: "358px", md: "320px" },
        boxShadow: "none",
        borderRadius: 0,
      }}
    >
      <Link to={`/video/${id}`}>
        <CardMedia
          image={snippet.thumbnails?.high?.url}
          alt={snippet.title}
          sx={{ width: { xs: "100%", sm: "358px" }, height: 180 }}
        />
      </Link>
      <CardContent sx={{ backgroundColor: "#1E1E1E", height: "106px" }}>
        <Link to={`/video/${id}`}>
          <Typography variant="subtitle1" fontWeight="bold" color="#FFF">
            {snippet.title.slice(0, 60)}
          </Typography>
        </Link>
        <Link to={`/channel/${snippet.channelId}`}>
          <Typography variant="subtitle2" color="gray">
            {snippet.channelTitle}
          </Typography>
        </Link>
      </CardContent>
    </Card>
  );
};

export default VideoCard;
